function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { FullColumn, RichTextEditor, TextButton, Typography } from 'seagull';
import { AIEdit24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { connectControllerToRichTextEditor } from "../../utils/react-hook-form.utils";
import styles from "./ServiceDescription.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetServiceDescriptionTID = parentTestId => getTestIds(parentTestId);
const ServiceDescription = _ref => {
  let {
    testId,
    hideLabel = false,
    onChange: _onChange = () => {},
    onHelpMeWriteClick,
    disabledHelpMeWrite = false,
    isDrawerOpen = false,
    disabled = false
  } = _ref;
  const {
    SERVICE_DESCRIPTION_AI
  } = useFeatureFlags();
  const {
    control,
    watch
  } = useFormContext();
  const isBundle = Boolean(watch('bundle'));
  const {
    ServiceDescriptionTestIds
  } = useMemo(() => GetServiceDescriptionTID(testId), [testId]);
  const isOnlyDisabledHelpMeWrite = !isDrawerOpen && disabledHelpMeWrite;
  const toolbarActions = SERVICE_DESCRIPTION_AI && !!onHelpMeWriteClick ? /*#__PURE__*/_jsx("div", {
    className: styles.helpMeWriteButtonWrapper,
    children: /*#__PURE__*/_jsx(TextButton, {
      tooltip: isOnlyDisabledHelpMeWrite && {
        title: 'Please name this service first',
        placement: 'top'
      },
      prefixIcon: /*#__PURE__*/_jsx("span", {
        className: cn({
          [styles.iconWrapper]: !isDrawerOpen
        }),
        children: /*#__PURE__*/_jsx(AIEdit24, {})
      }),
      underline: "none",
      weight: "normal",
      skin: isDrawerOpen ? 'focusPrimary' : 'primary',
      disabled: isOnlyDisabledHelpMeWrite,
      onClick: onHelpMeWriteClick,
      "data-testid": ServiceDescriptionTestIds.HelpMeWriteButton(),
      children: /*#__PURE__*/_jsx("span", {
        className: cn({
          [styles.textWrapper]: !isDrawerOpen
        }),
        "data-text": "Help me write",
        children: "Help me write"
      })
    })
  }) : null;
  return /*#__PURE__*/_jsxs(FullColumn, {
    gap: 8,
    alignItems: "start",
    children: [!hideLabel && /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      skin: "secondary",
      "data-testid": "".concat(testId, "-label"),
      children: isBundle ? 'Bundle description' : 'Service description'
    }), /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "description",
      rules: richTextValidation(),
      render: renderProps => /*#__PURE__*/_jsx(RichTextEditor, _objectSpread(_objectSpread({
        editorHeight: 310,
        placeholder: "Describe service (Optional)",
        "data-testid": testId
      }, connectControllerToRichTextEditor(renderProps)), {}, {
        onChange: v => {
          _onChange(v);
          connectControllerToRichTextEditor(renderProps).onChange(v);
        },
        toolbarActions: toolbarActions,
        disabled: disabled
      }))
    })]
  });
};
export default ServiceDescription;